import Vue from 'vue';
import { Commit } from 'vuex';
import { Role } from '@/interfaces/types';

interface RolesState {
	roles: {
		[id: number]: Role;
	};
}

export default {
	namespaced: true,
	state: {
		roles: {},
	} as RolesState,

	getters: {
		getRoles: (state: RolesState): Role[] => {
			return Object.values(state.roles);
		},

		getRole:
			(state: RolesState) =>
			(id: number): Role | undefined => {
				return state.roles[id];
			},
	},
	mutations: {
		SET_ROLES(state: RolesState, roles: Role[]): void {
			state.roles = Object.fromEntries(roles.map((role) => [role.id, role]));
		},

		CLEAN_ROLES(state: RolesState): void {
			state.roles = {};
		},
	},
	actions: {
		async fetchRoles({ commit }: { commit: Commit }): Promise<void> {
			const response = await Vue.axios.get(`${process.env.VUE_APP_API_URL}/reference/roles`);

			if (response && response.status === 200) {
				commit('SET_ROLES', response.data.data);
			}
		},

		cleanRoles({ commit }: { commit: Commit }): void {
			commit('CLEAN_ROLES');
		},
	},
};
